import { render, staticRenderFns } from "./CreateStudySetOverview.vue?vue&type=template&id=527f8758&scoped=true&"
import script from "./CreateStudySetOverview.vue?vue&type=script&lang=js&"
export * from "./CreateStudySetOverview.vue?vue&type=script&lang=js&"
import style0 from "./CreateStudySetOverview.vue?vue&type=style&index=0&id=527f8758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f8758",
  null
  
)

export default component.exports